import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HomePage, Landing, LoginPage } from "./components";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./context/AuthProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
    },
    mutations: {
      onError: (error) => {
        Sentry.withScope((scope) => {
          scope.setTag("source", "react-query-mutation");
          Sentry.captureException(error);
        });
      },
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Navigate to="/mini-course/6/home" replace />} />
            <Route path="/mini-course/6/login" element={<LoginPage />} />
            <Route
              path="/mini-course/6"
              element={
                <ProtectedRoute>
                  <Landing />
                </ProtectedRoute>
              }
            />
            <Route path="/mini-course/6/home" element={<HomePage />} />
            {/* Catch-all fallback route to prevent blank page */}
            <Route path="*" element={<Navigate to="/mini-course/6/home" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
      <ToastContainer
        position="top-center"
        rtl
        className="text-gray-800 text-sm"
        toastStyle={{
          fontFamily: "Kalameh, sans-serif",
        }}
      />
    </QueryClientProvider>
  );
};

export default App;
